module.exports = __webpack_public_path__ + "img/dfod_dg.0951a9d7.png";